<template>
<div id="dynamic-component" class="demo" >
  <div >
  </div>
  <v-row v-show="this.selectedTab === 'All'">
    <v-col  class="pl-6 pb-1">
      <div class="d-flex">
        <v-select  v-model="currentTab"  :items="tabs"  @change="changeItem" return-object  item-text="name"  item-value="id"  class="no-underline" append-icon="mdi-chevron-down"/>
      </div>
    </v-col>
    <v-col v-if="tabSelecting === 'All'"  class="pl-0 pb-1">
        <v-form ref="form" top="10px" class="search-box">
          <input  type="search"  v-model="searchName"  :placeholder="$i18n.t('placeholder_search_member_name')"  @keypress.enter="handleEnterPressed"  @blur="handleBlur"/>
          <v-btn  icon  class="ma-2"  max-width="30px"  max-height="30px"  v-on:click="handleSearchClick"
            style=" border-radius: 50%;  position: absolute;  right: -4px;  top: -3px; ">
            <img src="../../assets/search.png" width="28px" alt="required" />
          </v-btn>
        </v-form>
      </v-col>
  </v-row>
</div>
</template>
<script>
  import { TabNames } from "@/utilities/CommonUtilities";
  import { mapState, mapMutations, mapGetters } from "vuex";
  import { ListEvents, getUserRole, isApprover  } from "@/utilities/CommonUtilities";
  export default {
      data: () => {
        return {
            currentTab: '',
            page: 1,
            tabs: [],
            searchName: "",
            currentSearchName: "",
            tabHeaders:[],
            isSearchButtonClicked: false,
          };
      },
      mounted() {
        this.notifyBus.$on(ListEvents.vacationList, () => {
          this.searchName =  '';
          this.currentSearchName = '';
          this.setTabInfor();
        });
      },
      computed: {
        ...mapState(["userInfo"]),
        ...mapState({
            tabSelecting: state => state.homeData.currentTab,
            selectedTab: state => state.homeData.selectedTab,
        }),
        ...mapGetters({
          getFilterInfo: "homeData/getFilterInfo"
        }),
      },
      methods: {
        ...mapMutations({
            setCurrentTab: "homeData/setCurrentTab",
            saveFilter: "homeData/saveFilter",
        }),
        changeItem(itemName) {
          this.currentTab = itemName;
          var selectingTabName = TabNames.MyList;
          let index = this.tabs.findIndex(p => p == itemName);
          if(index == this.tabs.length - 1) {
            selectingTabName = TabNames.All;
          } else if (index == 1 && this.isShowIconInProgress()) {
            selectingTabName = TabNames.Requesting;
          }
          //clear search
          this.clearSearch();
          //set select box
          this.setCurrentTab(selectingTabName);
          this.notifyBus.$emit(ListEvents.changeTabName, selectingTabName);
        },
        getCurrentTab() {
          switch (this.tabSelecting) {
                case TabNames.MyList:
                    return this.tabs[0];
                case TabNames.Requesting:
                    return this.tabs[1];
                case TabNames.All:
                    return this.tabs[this.tabs.length-1];
            }
            return this.tabs[0];
        },
        getSelectedTab() {
          return this.selectedTab === TabNames.All ? this.tabHeaders[0] : this.tabHeaders[1]
        },
        searchVacation(event) {
          event.preventDefault();
          let filterInfoTemp = this.getFilterInfo;
          if (this.searchName.trim() != "") {
            const [year, monthIndex] = this.getFilterInfo.fromDate
              .split("-")
              .map(Number);
            let firstDay = new Date(year, monthIndex - 1, 1);
            let lastDay = new Date(year, monthIndex, 0);
            firstDay.setDate(firstDay.getDate() + 1);
            lastDay.setDate(lastDay.getDate() + 1);
            let firstDayOfMonth = firstDay.toISOString().substring(0, 10);
            let lastDayOfMonth = lastDay.toISOString().substring(0, 10);
            filterInfoTemp.fromDate = firstDayOfMonth;
            filterInfoTemp.toDate = lastDayOfMonth;
            filterInfoTemp.searchName = this.searchName;
          } else {
            filterInfoTemp.searchName = "";
          }
          this.saveFilter(filterInfoTemp);
          this.notifyBus.$emit(ListEvents.reloadByFilter);
        },
        isShowIconInProgress() {
          let userRole = getUserRole(this.userInfo.serviceInformation);
          return isApprover(userRole);
        },
        setTabInfor(){
          let myListString = this.$i18n.t("vacations_my_vacations");
          let approvedString = this.$i18n.t("vacations_all_vacations");
          let myListTitle = this.$i18n.t("tab_my_list");
          //set for Mobile
          if(this.isMobile){
            let requestingTitle = this.$i18n.t("tab_inprogress_list");
            let approvedListTitle = this.$i18n.t("tab_approved_list");
            if (this.isShowIconInProgress()) {
              this.tabHeaders = this.tabSelecting === TabNames.All ? [approvedListTitle, requestingTitle] : [myListTitle, requestingTitle];
            } else {
              this.tabHeaders = this.tabSelecting === TabNames.All ? [approvedListTitle, null] : [myListTitle, null];
            }
          }   
          this.tabs = [myListString, approvedString];
          this.currentTab = this.getCurrentTab();
        },
        clearSearch(){
          let filterInfoTemp = this.getFilterInfo;
          filterInfoTemp.searchName = "";
          this.searchName = "";
          this.saveFilter(filterInfoTemp);
        },
        handleBlur() {
          setTimeout(() => {
            if (!this.isSearchButtonClicked) {
              this.searchName = this.currentSearchName;
            }
            this.isSearchButtonClicked = false;  // Reset button click
          }, 500); // delay 500 ms after button click call
        },
        handleSearchClick(event) {
          this.currentSearchName = this.searchName;
          this.isSearchButtonClicked = true;
          this.searchVacation(event);
        },
        handleEnterPressed(event) {
          this.currentSearchName = this.searchName;
          this.searchVacation(event);
        }
      },
      inject: ["notifyBus"],
      created() {
        this.setTabInfor();
        //clear search input
        this.clearSearch();
      }
  }
</script>
<style scoped>

#btnAddNew{
  background-color: #F1BD42;
  width: 276px;
  color: white;
  font-size: 16px;
  height: 44px;
  font-weight: bolder;
  text-align: center;
  margin-left: 20px;
  margin-right: 0px;
  position: relative;
}
#imageAddNew{
  margin-left: -60px;
  margin-right: 30px
}
#btnFilter{
  max-width: 44px;
  min-width: 44px;
  background-color: #F1BD42;
  height: 44px;
  font-weight: bold;
}
.dynamic-component-tab-button {
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  cursor: pointer;
  margin-bottom: -1px;
  margin-right: -1px;
  height: 39px;
  width: 154px;
}
.dynamic-component-tab-button-active {
  background: #E561A9;
  color: #3FE090
}
#applyImage{
 margin-left: -40px;
 margin-right: 20px
}

  #btnAddNew{
    width: 200px;
    margin-right: 40px;
  }
  #leftColumn{
    z-index: 1;
    position: absolute;
    top: 70px;
  }
  #rightColumn{
    z-index: 2; position: absolute; top: 0px; right:0px;
    margin-right: -15px
  }
  #applyImage{
    margin-left: 05px;
    margin-right: 05px
  } 

.search-box {
  position: relative;
  border-radius: 20px;
  overflow: hidden;
  margin: 0 15px;
}

.search-box input[type="search"] {
  width: 100%;
  padding: 10px 20px 10px 10px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 20px;
  outline: none;
  line-height: normal;
}

.search-box input[type="search"]:focus {
  border: 1px solid rgb(116, 116, 243);
}

.search-box .icon {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 20px;
  color: #ccc;
}
.no-underline >>> .v-input__slot {
  margin-bottom: 0px !important;
}
.no-underline >>> .v-input__slot:before {
  border-width: 0px !important;
  border-style: none !important;
}

.no-underline >>> .v-input__slot:after {
  border-width: 0px !important;
  border-style: none !important;
}

.no-underline >>> .v-select__selections {
  max-width: 80px !important;
  font-weight: bold;
  font-size: 14px;
}

.no-underline >>> .v-input__append-inner {
  margin-left: -10px !important;
  margin-top: 5px !important;
}

.no-margin-right {
  margin-right: 0px !important;
  margin-left: 0px !important;
}

.v-list {
  padding: 0px !important;
}
::v-deep .v-text-field {
  padding-top: 0px !important;
}
::v-deep .v-select__selection--comma {
  overflow: unset;
}
  .row {
    display: grid;
    grid-template-columns: 1fr 3fr;
  }

  .btnLeftTab{
    width: 100%;
  }
  #cardTabMyList{
    padding-left: 10px;
  }
  ::v-deep  .dynamic-component-tab-button{
    width: 100%;
  }
  ::v-deep .dynamic-component-tab-button.dynamic-component-tab-button-active{
    width: 100%;
  }

  @media only screen and (max-width: 767px) {
  ::v-deep .v-select__selection--comma{
      padding-left: 10px !important;
  }
  .no-underline >>> .v-input__append-inner {
    padding-left: 7px;
  }
  .v-application .pb-1{
    margin-bottom: -12px;
  }
}

</style>

